import {createTheme} from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: "#0b99da",  
            light: "#0da2e7",
            dark: "#073C92",  
            contrastText: "#fff",
        },
        background: {
            main: "#fff",
        },
    },

    typography: {
        fontFamily: "'Inter', sans-serif",
        primary: "#0f172a",
        secondary: "#64748b",
        
        h1:{
            color: "#0f172a",
        },
        h3:{
            color: "#0f172a",
        },
        h5:{
            color: "#0b99da",
        },
        h6:{
            color: "#64748b",
        },
        subtitle1: {
            color: "#64748b",
        },
        subtitle2: {
            color: "#0f172a",
            fontWeight: 500
        },
        body1: {
            color: "#0f172a",
        },
        caption:{
            color: "#64748b",
            fontSize: 12,
        }
    },
})

export default theme